<template>
  <div class="tva-row">
    <div class="big-number tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-4 tva-col-md-7">
      <div class="number">{{content.value}}</div>
      <div>
        <span class="currency">{{content.currency}}</span>
        <span class="caption">{{content.caption}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"]
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
.big-number {
  font-size: 0.9rem;
  font-family: "Avenir Next";
  margin-top: 1em;
  margin-bottom: 5em;
  .number {
    font-size: 2.5rem;
    font-weight: 900;
    color: lightgray;
  }
  .currency {
    font-weight: 400;
    border-right: 1px solid $eni-yellow;
    margin-right: 0.5em;
    padding-right: 0.5em;
  }
  .caption {
    font-weight: 600;
  }
}
</style>
